<template>
   <v-icon :class="className" :icon="iconName" :size="size" :color="color"/>
</template>

<script>

export default {
  name: 'Icon',
  props: {
    icon: { type: String, default: '' },
    color: { type: String, default: '' },
    size: { type: [Number, String], default: '' },
    variant: { type: String, default: '' },
  },
  computed: {
    className() {
      switch (this.variant) {
        case 'outlined':
          return 'material-icons-outlined';
        case 'rounded':
          return 'material-icons-rounded';
        case 'sharp':
          return 'material-icons-sharp';
        case 'twotone':
          return 'material-icons-two-tone';
        default:
          return '';
      }
    },
    iconName() {
      return `md:${this.icon}`;
    },
  },
};
</script>
